import { ColumnWidth as ColumnWidth_internal } from "./ColumnWidth";
import { ensureBool } from "igniteui-react-core";
/**
 * Represents a width of a column.
*/
var IgrColumnWidth = /** @class */ /*@__PURE__*/ (function () {
    function IgrColumnWidth() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrColumnWidth.prototype.createImplementation = function () {
        return new ColumnWidth_internal();
    };
    Object.defineProperty(IgrColumnWidth.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrColumnWidth.prototype.onImplementationCreated = function () {
    };
    IgrColumnWidth.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrColumnWidth.prototype, "isStarSized", {
        /**
         * Gets or sets whether to use star sizing for the column's width
        */
        get: function () {
            return this.i.c;
        },
        set: function (v) {
            this.i.c = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrColumnWidth.prototype, "value", {
        /**
         * Gets or sets the fixed width or the proportional width of the column, depending on whether this width is a star width.
        */
        get: function () {
            return this.i.f;
        },
        set: function (v) {
            this.i.f = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrColumnWidth.prototype, "minimumWidth", {
        /**
         * Gets or sets a minimum width to use when star sizing.
        */
        get: function () {
            return this.i.e;
        },
        set: function (v) {
            this.i.e = +v;
        },
        enumerable: true,
        configurable: true
    });
    IgrColumnWidth.prototype.findByName = function (name) {
        return null;
    };
    return IgrColumnWidth;
}());
export { IgrColumnWidth };
//# sourceMappingURL=igr-column-width.js.map
